import { Typography, TypographyProps } from "@mui/material";

type Props = Omit<TypographyProps<"blockquote">, "component">;

export default function Quotation({ children, ...rest }: Props) {
  return (
    <Typography
      component="blockquote"
      variant="body1"
      {...rest}
      sx={[
        {
          color: "text.primary",
        },
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
      ]}
    >
      "{children}"
    </Typography>
  );
}
